// extracted by mini-css-extract-plugin
export default {"oddRow":"table-show_oddRow__QGNFe","evenRow":"table-show_evenRow__3sIWh","prodsLine":"table-show_prodsLine__P8Ch8"};